module.exports = __webpack_public_path__ + "static/media/home16.9963f36c.jpg";